<template>
  <div ref="grid_buttons" class="grid-buttons d-flex text-right">
    <component :is="button.type" v-for="button in tableButtons" :key="button.id" :class="button.class" @click="buttonClicked" @submit="button.handler" :options="button.options" class="m-1" />
  </div>
</template>
<script lang="ts">
  import { defineComponent, PropType } from 'vue'

  export default defineComponent({
    name: 'grid-buttons',
    props: {
      tableButtons: { type: Array as PropType<any[]> },
    },
    methods: {
      buttonClicked(button: any, e: any) {
        if (e)
          e.preventDefault()

        var handler = button.handler
        if (handler != null) {
          handler(button)
        }
      },
    }
  })
</script>
<style>
  .grid-buttons button i {
    font-size: 13px;
  }
</style>